import React from 'react';
import { Phone, Calendar } from 'lucide-react';
import { Translations } from '../types/language';
import { generatePDF } from '../utils/pdfGenerator';
import { CostBreakdown } from '../types/renovation';

interface Props {
  translations: Translations;
  breakdown?: CostBreakdown[];
  totalCost?: number;
  userData?: {
    name: string;
    email: string;
    phone: string;
  };
}

export function ContactSection({ translations, breakdown = [], totalCost = 0, userData }: Props) {
  const handleDownload = () => {
    if (breakdown && totalCost && userData) {
      generatePDF({
        breakdown,
        totalCost,
        language: translations.language,
        userData
      });
    }
  };

  return (
    <div className="flex flex-col items-center gap-4 mt-6">
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <a
          href="tel:+33681418107"
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-200 shadow-sm"
        >
          <Phone className="w-5 h-5 mr-2" />
          {translations.contactNow}
        </a>
        <a
          href="https://calendly.com/rivierams28/amgbatimantfr"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-blue-50 hover:bg-blue-100 transition-colors duration-200 shadow-sm"
        >
          <Calendar className="w-5 h-5 mr-2" />
          {translations.scheduleCall}
        </a>
      </div>
      {breakdown.length > 0 && totalCost > 0 && userData && (
        <button
          onClick={handleDownload}
          className="text-blue-600 hover:text-blue-800 hover:underline text-sm mt-2"
        >
          {translations.language === 'fr' ? 'Télécharger le devis en PDF' : 'Download quote as PDF'}
        </button>
      )}
    </div>
  );
}